import { default as _91_46_46_46slug_9347Wc4bxztpMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/[...slug].vue?macro=true";
import { default as index7MG6YSuzbXMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/auth/index.vue?macro=true";
import { default as indexUevGFBOy4VMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93oPQCMcK2HCMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93xCK8chAnV7Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93WnCOTXocKgMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93pXNZLvETpZMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/news/[slug].vue?macro=true";
import { default as organisationsYK67eaY8wHMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventswBiO32gBG7Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programsvlBsDgndLEMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexzKpvbmEZFTMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/processes/index.vue?macro=true";
import { default as dungeonQQmKLzrCTAMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsey5QDy7ZklMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexZriYfUvQVuMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/secret/index.vue?macro=true";
import { default as indexq8dcNdqS8rMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDatakHTR4AU1ABMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassh2skWSC1L9Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93ThfNw5kXBGMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexdzCGuxeM66Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataUWB8MGt6W2Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFields86BoWQC4PbMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsBKIqGX61CzMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightspnwlxtDJ0OMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93BRSrSmtjtYMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as index1PsGIXi3bzMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesjLCENP17GjMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDatafattTf0IWNMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93CWTRBO6T7xMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexjq1MfdsBIpMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiest7GgpodMjKMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDatatRSwx45MVnMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93LXwXBnd9JwMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexBdu5oosJWDMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseData6OvGCBpA2vMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93PfEu1uQZCbMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexkEms5QfLeDMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDatavJgIXtnOi2Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassavSOZLetKSMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsgbR8sOJCiVMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93qV4IsolPLmMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as index56crG2SqDFMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiesY0Q2rGDlXSMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDatayDNE1XCmbuMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodsjnxiTspjvHMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_93KnkymXMoHkMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexh0nalPDnGFMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitieskFTtGHSZqxMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseData3Jku9IGVXvMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsQjEW2RLtSyMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93DBFs0yLsSIMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexexPPnGlii7Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDatajdqNfrtKKeMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearData9Koel0foRRMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_931p9aOkLVZmMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexP9ehewZi2vMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDatatCpIoYa5O4Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93n7f9QBmEIcMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as index2DFPfB38h3Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupsy9YBkuOT7MMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDatapNZgF60X0gMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93ChK0rpzycJMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexWwRXcgEaajMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesxCuXzK7prEMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesR3CuRPdCr6Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsBSB0UfFd5oMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDataFLgbA7zK3UMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiasA8atKsXTWyMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesNcvbcyryPeMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93mef0EgXuJKMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexKg2ib6N83TMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionsr7PtaPB37QMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltwaTfMGxW22Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDataLXLoJjViMZMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsJfEcRvJF9ZMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93EsN46dvN9ZMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as index6dTtdijVVFMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as payments9hovMDeq7BMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesD4xwfEYlfsMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDatarHh9lwtdS6Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93vyU4kdbM7GMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/processes/[id].vue?macro=true";
import { default as indexzEdPrBLN4KMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovalkG9aku6phqMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_93yUXE3v1D3QMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as index3y2tbrBfNsMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersFb8V550sWpMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitieskO5kFnie5XMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsPurL027WHgMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDataZhoNi7psw8Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesgpwNK6gKbZMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConceptdnFpUrJ3lrMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementr4wLwSQPFVMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersp9wUyurnQUMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93Ay5yw1ICdZMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexFRhzahNIHUMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisations8r2fFqTHLKMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesFnsvEQnghMMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDataEjaqOsRDkDMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFiltersegr7QVowTbMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignatureAZkBBy0YahMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93YlACaKmow6Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users/[id].vue?macro=true";
import { default as index9UpBkxhwERMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersFFSqdCkl2XMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users.vue?macro=true";
import { default as settingshpKVaaI1atMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesGwDfS3RrJMMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDatansqxL1KrtXMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93DgkubcwsMCMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as index2hKsdCxU9YMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as serviceiwWVbUnwO4Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service.vue?macro=true";
import { default as languagexfyCavuFbNMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseData307fEnS5iKMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesm9vqCt8vdoMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementApbj5WcnREMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersgW4ZwiST9pMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93VGh8vtX2uKMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDatar3eRnmUa2mMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureNXz2izSXMVMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93HKYaF2xPydMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/users/[id].vue?macro=true";
import { default as indexkiSdqjiTMmMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/users/index.vue?macro=true";
import { default as settingscFX1aJWv06Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings.vue?macro=true";
import { default as signatureQ5nmfiKsCtMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/signature.vue?macro=true";
import { default as sportbizzGewZ8coxO0Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93XHFh21rNOHMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93rHi2iPWJCnMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as index4jQ967T0f6Meta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93b6SjfiHUPaMeta } from "/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_9347Wc4bxztpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: index7MG6YSuzbXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexUevGFBOy4VMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93oPQCMcK2HCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93xCK8chAnV7Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93WnCOTXocKgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsYK67eaY8wHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexzKpvbmEZFTMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: serviceiwWVbUnwO4Meta?.name,
    path: "/service",
    meta: serviceiwWVbUnwO4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDatatCpIoYa5O4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexq8dcNdqS8rMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93ThfNw5kXBGMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexdzCGuxeM66Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93BRSrSmtjtYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: index1PsGIXi3bzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93CWTRBO6T7xMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexjq1MfdsBIpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93LXwXBnd9JwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexBdu5oosJWDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93PfEu1uQZCbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexkEms5QfLeDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93qV4IsolPLmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: index56crG2SqDFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93KnkymXMoHkMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexh0nalPDnGFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93DBFs0yLsSIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsQjEW2RLtSyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexexPPnGlii7Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_931p9aOkLVZmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexP9ehewZi2vMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93n7f9QBmEIcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesxCuXzK7prEMeta?.name,
    path: "parishes",
    meta: parishesxCuXzK7prEMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93ChK0rpzycJMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionsr7PtaPB37QMeta?.name,
    path: "regions",
    meta: regionsr7PtaPB37QMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93mef0EgXuJKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: payments9hovMDeq7BMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93EsN46dvN9ZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: index6dTtdijVVFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93vyU4kdbM7GMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexzEdPrBLN4KMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovalkG9aku6phqMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingshpKVaaI1atMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersFb8V550sWpMeta?.name,
    path: "loginProviders",
    meta: loginProvidersFb8V550sWpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93yUXE3v1D3QMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: index3y2tbrBfNsMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisations8r2fFqTHLKMeta?.name,
    path: "organisations",
    meta: organisations8r2fFqTHLKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93Ay5yw1ICdZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexFRhzahNIHUMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersFFSqdCkl2XMeta?.name,
    path: "users",
    meta: usersFFSqdCkl2XMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93YlACaKmow6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: index9UpBkxhwERMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93DgkubcwsMCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: index2hKsdCxU9YMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingscFX1aJWv06Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93VGh8vtX2uKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93HKYaF2xPydMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexkiSdqjiTMmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signatureQ5nmfiKsCtMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzGewZ8coxO0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93XHFh21rNOHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93rHi2iPWJCnMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: index4jQ967T0f6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93b6SjfiHUPaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250613110026/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]